import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css'; // Importa seu CSS global, incluindo Tailwind
import App from './App'; // Importa seu componente App principal

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
